import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button, Card, CardDescription, CardHeader, CardTitle } from '@monigo/ui';
import { useKycStatus } from './api.js';
import { LoadingScreen } from '../../components/Status/LoadingScreen.js';

export function KycPendingPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data, isLoading } = useKycStatus();
  const [approvedDismissed, setApprovedDismissed] = useState(false);

  if (isLoading) return <LoadingScreen />;

  const submission = data?.latest_submission;

  // If approved, show approval message
  if (submission?.status === 'approved' && !approvedDismissed) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>{t('kyc.approvedTitle')}</CardTitle>
          <CardDescription>{t('kyc.approvedBody')}</CardDescription>
        </CardHeader>
        <div className="px-5 pb-5">
          <Button onClick={() => setApprovedDismissed(true)} variant="secondary">
            {t('kyc.dismissApproved')}
          </Button>
        </div>
      </Card>
    );
  }

  // If rejected, show rejection reason with retry
  if (submission?.status === 'rejected') {
    return (
      <Card>
        <CardHeader>
          <CardTitle>{t('kyc.rejectedTitle')}</CardTitle>
          <CardDescription>
            {t('kyc.rejectedBody', { reason: submission.rejection_reason ?? t('kyc.noReason') })}
          </CardDescription>
        </CardHeader>
        <div className="px-5 pb-5">
          <Button onClick={() => navigate('/kyc')}>
            {t('kyc.retryCta')}
          </Button>
        </div>
      </Card>
    );
  }

  // Pending
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('kyc.pendingTitle')}</CardTitle>
        <CardDescription>{t('kyc.pendingBody')}</CardDescription>
      </CardHeader>
    </Card>
  );
}
